import type { PriceWindowSnapshot } from '../api/types'

// A `since_recovery` window has two distinct shapes and only one of them is
// about the outage itself:
//
//   - the window reaches back into the unavailable interval, so the durable
//     recovery moment is its honest start (`effective_start` < baseline);
//   - the window sits entirely inside the supported range, but the pool was
//     dormant across the outage and its only earlier price is outside that
//     range, so the window starts where our first usable price is
//     (`effective_start` === baseline).
//
// Calling the second case "since data recovery" would date the recovery to
// today, which is false — hence this split.
export function recoveryClipsWindowStart(window: PriceWindowSnapshot): boolean {
  if (!window.effective_start || !window.baseline_source_ts) return false
  const start = Date.parse(window.effective_start)
  const baseline = Date.parse(window.baseline_source_ts)
  return Number.isFinite(start) && Number.isFinite(baseline) && start < baseline
}
